var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';
import { Box, Dialog, DialogContent, DialogTitle, Grid, IconButton, TextField, Tooltip, Typography } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { Reorder } from '@material-ui/icons';
import { ConfigSortableList } from '@sierralabs/core-ui';
import { useQueryContext } from '@sierralabs/query-ui';
const StyledDiv = styled(Grid) `
  width: 100%;
  display: flex;
  align-items: center;
  .grid-input {
    flex: 1;
  }
  .grid-button {
    padding-left: 1px;
    margin-top: 16px;
  }
`;
export const SiteQueryPicker = props => {
    const { value: queryIds, multiple = true, hideReorder, onChange } = props, textFieldProps = __rest(props, ["value", "multiple", "hideReorder", "onChange"]);
    const [openReorderDialog, setOpenReorderDialog] = useState(false);
    const { queries, queryGroups } = useQueryContext();
    const value = useMemo(() => {
        return queries
            .filter(query => queryIds.includes(query.id))
            .sort((a, b) => {
            // sort based on queryIds
            const aIndex = queryIds.indexOf(a.id);
            const bIndex = queryIds.indexOf(b.id);
            return aIndex - bIndex;
        });
    }, [queries, queryIds]);
    const options = useMemo(() => {
        const options = [];
        for (const group of queryGroups || []) {
            for (const query of group.queries) {
                options.push({ query, groupBy: group.name });
            }
        }
        return options;
    }, [queryGroups]);
    const selected = useMemo(() => {
        return options
            .filter(option => value.some(query => query.id === option.query.id))
            .sort((a, b) => {
            // sort based on value array
            const aIndex = value.findIndex(query => query.id === a.query.id);
            const bIndex = value.findIndex(query => query.id === b.query.id);
            return aIndex - bIndex;
        });
    }, [value, options]);
    useEffect(() => {
        if (selected.length === 0) {
            setOpenReorderDialog(false);
        }
    }, [selected]);
    const input = (React.createElement(Autocomplete, { fullWidth: true, multiple: multiple, options: options, value: multiple ? selected : selected[0] || null, groupBy: option => option.groupBy, getOptionLabel: option => option.query.name, onChange: (_, option) => {
            const options = Array.isArray(option) ? option : option ? [option] : [];
            onChange === null || onChange === void 0 ? void 0 : onChange(options.map(option => option.query));
        }, renderInput: params => {
            const inputProps = Object.assign(Object.assign(Object.assign({}, params.InputProps), { disableUnderline: true }), textFieldProps.InputProps);
            if (!inputProps.disableUnderline) {
                delete inputProps.disableUnderline;
            }
            return (React.createElement(TextField, Object.assign({}, params, { fullWidth: true, size: 'small' }, textFieldProps, { InputProps: inputProps })));
        } }));
    return hideReorder ? (React.createElement(React.Fragment, null, input)) : (React.createElement(React.Fragment, null,
        React.createElement(StyledDiv, null,
            React.createElement("div", { className: 'grid-input' }, input),
            selected.length > 0 && (React.createElement("div", { className: 'grid-button' },
                React.createElement(Tooltip, { title: 'Reorder' },
                    React.createElement(IconButton, { size: 'small', onClick: () => setOpenReorderDialog(true) },
                        React.createElement(Reorder, { fontSize: 'small' })))))),
        React.createElement(Dialog, { fullWidth: true, maxWidth: 'xs', open: openReorderDialog, onClose: () => setOpenReorderDialog(false) },
            React.createElement(DialogTitle, null, "Reorder Queries"),
            React.createElement(DialogContent, null,
                React.createElement(ConfigSortableList, { data: value, keyIndicator: item => item.id, renderItem: item => (React.createElement(Box, { ml: 1 },
                        React.createElement(Typography, { variant: 'body2' }, item.name))), onMove: (sourceIndex, destinationIndex) => {
                        const copy = [...value];
                        const [item] = copy.splice(sourceIndex, 1);
                        copy.splice(destinationIndex, 0, item);
                        onChange === null || onChange === void 0 ? void 0 : onChange(copy);
                    }, onDelete: (index) => {
                        const copy = [...value];
                        copy.splice(index, 1);
                        onChange === null || onChange === void 0 ? void 0 : onChange(copy);
                    } })))));
};
export default SiteQueryPicker;
//# sourceMappingURL=SiteQueryPicker.js.map